import { api } from '../api';
import type { PaginationParams, PaginatedResponse } from '@/types/common';
import type { PopularRecipe } from '@/types/recipe';

export interface PopularQueryParams extends PaginationParams {
  days?: number;
}

export const recipeViewRequests = {
  record: (recipeId: number) =>
    api.post<{ recorded: boolean }>(`/recipe-views/${recipeId}`),

  popular: (params?: PopularQueryParams) => {
    const sp = new URLSearchParams();
    if (params?.page != null) sp.set('page', params.page.toString());
    if (params?.limit != null) sp.set('limit', params.limit.toString());
    if (params?.days != null) sp.set('days', params.days.toString());
    const qs = sp.toString();
    return api.get<PaginatedResponse<PopularRecipe>>(`/recipe-views/popular${qs ? `?${qs}` : ''}`);
  },
};
